import styles from './CreationIdentityPanel.module.scss';
import type { CharacterCreationDraft } from '../../hooks';
import { Button, CharacterAttributes, Panel, Separator, Textbox } from '@sorrem-client/ui/components';
import { ATTRIBUTE_MAX, ATTRIBUTE_MIN } from '@sorrem/shared';

interface CreationIdentityPanelProps {
    draft: CharacterCreationDraft;
}

/** Character creation's side-panel content: gender/name plus the attribute allocator. */
export function CreationIdentityPanel({ draft }: CreationIdentityPanelProps): JSX.Element {
    return (
        <Panel className={styles.identityPanel}>
            <h3 className={styles.panelTitle}>Identity</h3>
            <Separator />
            <div className={styles.genderSelection}>
                <Button
                    variant={draft.gender === 'male' ? 'primary' : 'secondary'}
                    onClick={() => draft.setGender('male')}
                    disabled={draft.isSaving}
                    className={styles.genderButton}
                >
                    Male
                </Button>
                <Button
                    variant={draft.gender === 'female' ? 'primary' : 'secondary'}
                    onClick={() => draft.setGender('female')}
                    disabled={draft.isSaving}
                    className={styles.genderButton}
                >
                    Female
                </Button>
            </div>
            <Textbox
                id="character-name"
                type="text"
                aria-label="Character name"
                className={styles.nameInput}
                placeholder="Enter character name"
                value={draft.name}
                onChange={(event) => draft.setName(event.target.value)}
                disabled={draft.isSaving}
            />

            <Separator />
            <h3 className={styles.panelTitle}>Core Attributes</h3>
            <p className={styles.attributeFraming}>
                When the Veil tore through you, it opened something. Choose what it amplified.
            </p>
            <div className={styles.statsEditor}>
                <CharacterAttributes
                    attributes={draft.attributes}
                    mode="edit"
                    remainingPoints={draft.remainingPoints}
                    minValue={ATTRIBUTE_MIN}
                    maxValue={ATTRIBUTE_MAX}
                    isDisabled={draft.isSaving}
                    onChangeAttribute={draft.onChangeAttribute}
                />
            </div>

            {(!draft.canCreateCharacter || draft.createError !== null) && (
                <div className={styles.errorRow}>
                    {!draft.canCreateCharacter && (
                        <p className={styles.errorText}>
                            You have reached your character limit for this account tier.
                        </p>
                    )}
                    {draft.createError !== null && <p className={styles.errorText}>{draft.createError}</p>}
                </div>
            )}
        </Panel>
    );
}
